/**
 * Experiment/feature flag key registry.
 * All experiment and feature flag keys managed through the experimentation system.
 * Use these keys instead of literal strings everywhere.
 */
const ExperimentKey = Object.freeze({
    /** @deprecated Expired Jan 2025. Backend callers still reference this — clean up separately. */
    FreeTrainGpu: "free-train-gpu",
    /** Gradual rollout of the Continuous Improvement feature via PostHog. */
    ContinuousImprovementRollout: "continuous-improvement-rollout"
});

module.exports = { ExperimentKey };
